module.exports = __webpack_public_path__ + "static/media/research-hero.ce5707dd.jpg";